module.exports = __webpack_public_path__ + "media/styles/images/png/circle-check-teal-on-white-4d8a24c701e8383451e0cf72ff2b376f.png";